// Mock data for Pierce Premier Cleaning Services

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Palm Bay, FL",
    rating: 5,
    text: "Pierce Premier did an amazing job with our move-out cleaning. The house looked brand new! Very professional and thorough.",
    service: "Move-Out Cleaning"
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    location: "Melbourne, FL",
    rating: 5,
    text: "We use them for our office cleaning every week. Always on time, always spotless. Highly recommend!",
    service: "Commercial Cleaning"
  },
  {
    id: 3,
    name: "Linda Patterson",
    location: "Satellite Beach, FL",
    rating: 5,
    text: "The senior check-in service is wonderful. They check on my mother and keep her home clean. Such peace of mind!",
    service: "Senior Home Check-In"
  },
  {
    id: 4,
    name: "David Chen",
    location: "Viera, FL",
    rating: 5,
    text: "Best deep cleaning service in Brevard County! They got stains out I thought were permanent. Amazing attention to detail.",
    service: "Deep Cleaning"
  },
  {
    id: 5,
    name: "Jennifer Martinez",
    location: "Palm Bay, FL",
    rating: 5,
    text: "Our vacation rental always looks perfect thanks to Pierce Premier. Guests constantly compliment the cleanliness!",
    service: "Vacation Home Cleaning"
  },
  {
    id: 6,
    name: "Robert Williams",
    location: "West Melbourne, FL",
    rating: 5,
    text: "After construction cleanup was flawless. They removed all dust and debris. Ready for move-in immediately!",
    service: "Post-Construction Cleaning"
  }
];

export const galleryImages = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    after: "https://images.unsplash.com/photo-1585421514284-efb74c2b69ba?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    title: "Kitchen Deep Clean",
    description: "Complete kitchen transformation"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    after: "https://images.unsplash.com/photo-1563453392212-326f5e854473?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    title: "Living Room Refresh",
    description: "Detailed living space cleaning"
  },
  {
    id: 3,
    before: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    after: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    title: "Bathroom Sparkle",
    description: "Spotless bathroom cleaning"
  },
  {
    id: 4,
    before: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    after: "https://images.unsplash.com/photo-1642505172378-a6f5e5b15580?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0",
    title: "Office Space Clean",
    description: "Professional commercial cleaning"
  }
];

export const services = {
  residential: [
    {
      id: "houses",
      name: "Houses",
      description: "Complete home cleaning services for houses of all sizes",
      features: [
        "Dusting and vacuuming all rooms",
        "Kitchen and bathroom sanitization",
        "Floor mopping and care",
        "Surface wiping and polishing",
        "Trash removal"
      ]
    },
    {
      id: "apartments",
      name: "Apartments",
      description: "Efficient cleaning solutions for apartments and condos",
      features: [
        "Full apartment cleaning",
        "Balcony and patio cleaning",
        "Kitchen appliance cleaning",
        "Bathroom deep cleaning",
        "Window sill cleaning"
      ]
    },
    {
      id: "vacation-homes",
      name: "Vacation Homes",
      description: "Turnover cleaning for vacation rentals and seasonal properties",
      features: [
        "Quick turnover service",
        "Linen and towel service coordination",
        "Guest-ready preparation",
        "Restocking essentials",
        "Property inspection"
      ]
    }
  ],
  commercial: [
    {
      id: "small-offices",
      name: "Small Offices",
      description: "Professional office cleaning for small business spaces",
      features: [
        "Desk and workspace cleaning",
        "Break room sanitization",
        "Restroom cleaning and restocking",
        "Floor vacuuming and mopping",
        "Trash and recycling removal"
      ]
    },
    {
      id: "retail-locations",
      name: "Retail Locations",
      description: "Storefront and retail space cleaning services",
      features: [
        "Floor care and maintenance",
        "Window and glass cleaning",
        "Display area dusting",
        "Restroom maintenance",
        "Entrance area cleaning"
      ]
    }
  ],
  specialized: [
    {
      id: "deep-cleaning",
      name: "Deep Cleaning",
      description: "Intensive cleaning for heavily soiled or neglected spaces",
      features: [
        "Detailed scrubbing and sanitization",
        "Behind and under furniture",
        "Baseboard and trim cleaning",
        "Cabinet and appliance interiors (when selected)",
        "Customizable deep-clean options"
      ]
    },
    {
      id: "move-cleaning",
      name: "Move-In / Move-Out Cleaning",
      description: "Thorough cleaning for property transitions",
      features: [
        "Empty property cleaning",
        "All surfaces sanitized",
        "Cabinet and closet cleaning",
        "Window tracks and sills",
        "Final walk-through ready"
      ]
    },
    {
      id: "window-cleaning",
      name: "Window Cleaning",
      description: "Professional window cleaning inside and out",
      features: [
        "Interior window cleaning",
        "Exterior window cleaning",
        "Screen cleaning",
        "Track and frame cleaning",
        "Professional results"
      ]
    },
    {
      id: "post-construction",
      name: "Post-Construction Cleaning",
      description: "Complete cleanup after construction or renovation",
      features: [
        "Dust and debris removal",
        "Surface protection removal",
        "Floor cleaning and polishing",
        "Fixture cleaning",
        "Final detail work"
      ]
    }
  ],
  additional: [
    {
      id: "senior-checkin",
      name: "Discreet Home Check-In Service",
      description: "A thoughtful service for families who want an extra set of trusted eyes on a loved one's home",
      features: [
        "Scheduled home visits",
        "Light housekeeping based on selected service",
        "Visual check of general home conditions",
        "Identification of obvious maintenance or safety concerns",
        "Discreet written update to authorized family contact",
        "Respectful service protecting resident's dignity and privacy"
      ],
      highlighted: true,
      disclaimer: "This is not a medical, nursing, emergency-response, or personal-care service."
    }
  ]
};

export const businessInfo = {
  name: "Pierce Premier Cleaning Services",
  phone: "321-408-1347",
  email: "info@piercepremiercleaning.com",
  serviceArea: ["Palm Bay, Florida", "Brevard County, Florida"],
  hours: {
    weekdays: "8:00 AM - 6:00 PM",
    saturday: "9:00 AM - 4:00 PM",
    sunday: "Closed"
  }
};
